import { connect, MapDispatchToPropsFunction } from 'react-redux'
import { State } from 'interfaces/state'
import TrendRank, { TrendRankStateProps, TrendRankDispatchProps, TrendRankOwnProps } from 'components/features/pfm/TrendRank/TrendRank'
import { setTrendModeActionCreator } from 'actions/globalActions'
import { withComparisonSelector } from 'components/features/pageFilters/selectors'

const mapStateToProps = (state: State, { type }: TrendRankOwnProps): TrendRankStateProps => ({
  mode: state.app[type].trendMode,
  withComparison: withComparisonSelector(state),
})

const mapDispatchToProps: MapDispatchToPropsFunction<TrendRankDispatchProps, TrendRankOwnProps> = (dispatch, { type }) => ({
  setMode: (mode) => dispatch(setTrendModeActionCreator(type, mode)),
})

const TrendRankContainer = connect<TrendRankStateProps, TrendRankDispatchProps, TrendRankOwnProps>(mapStateToProps, mapDispatchToProps)(TrendRank)
export default TrendRankContainer
